import toRegexRange from "to-regex-range";
export function warning(warning) {
    throw new Error(warning);
    //console.warn(warning);
}
export const defaultParseError = (state) => (options) => {
    warning('I expect "' + options.join('", "') + '" but found "' + state.bytesToRead + '"');
};
export function parseString(parseState, options, success = null, failure = null) {
    for (let option of options) {
        if (parseState.bytesToRead.startsWith(option)) {
            parseState.bytesToRead = parseState.bytesToRead.substring(option.length);
            success && success(option);
            return parseState;
        }
    }
    failure && failure(options);
    return parseState;
}
/**
 * Helper method for sorting strings for parseString to avoid overlaps (larger strings first)
 *
 * It also removes duplicate values
 */
export function sortLength(list) {
    const copy = Array.from(new Set(list));
    copy.sort((a, b) => {
        return Math.sign(b.length - a.length);
    });
    return copy;
}
export function toString(value) {
    if (value === true) {
        return 'on';
    }
    if (!value && value !== 0) {
        return '';
    }
    if (value instanceof File) {
        return value.name;
    }
    return String(value);
}
export function generateRegexForRange(minimum, maximum) {
    return new RegExp('^' + toRegexRange(minimum, maximum) + '(\b|$)');
}
export function parseNumber(parseState, minimum, maximum, success = null, failure = null) {
    const regex = generateRegexForRange(minimum, maximum);
    const match = parseState.bytesToRead.match(regex);
    if (!match) {
        failure && failure(['A number between ' + minimum + ' and ' + maximum]);
        return parseState;
    }
    const number = Number(match[0]);
    parseState.bytesToRead = parseState.bytesToRead.substring(match[0].length);
    if (match[0] === String(number)) {
        success && success(Number(number));
    }
    else {
        failure && failure(['A number']);
    }
    return parseState;
}
export function parsePrefixedNumber(parseState, numberOfCharacters, success = null, failure = null) {
    const number = parseState.bytesToRead.substring(0, numberOfCharacters);
    parseState.bytesToRead = parseState.bytesToRead.substring(numberOfCharacters);
    const data = String(Number(number));
    if (number !== '' && Number(number) === Number(data)) {
        success && success(Number(number));
    }
    else {
        failure && failure(['A number']);
    }
    return parseState;
}
//# sourceMappingURL=utils.js.map
